import request from '@/utils/request'
import requestMessage from '@/utils/requestMessage'

export function getAllBanner() {
  return request({
    url: 'carousel/GetAll',
    method: 'get'
  })
}

export function getNewsList(params) {
  return request({
    url: 'news/GetPublishNewsList',
    method: 'get',
    params
  })
}

export function getNew(id) {
  return request({
    url: `news/GetNewsById?newsId=${id}`,
    method: 'get'
  })
}

export function getPublishJobs() {
  return request({
    url: 'job/GetPublishJobsList',
    method: 'get'
  })
}

export function getSecurityCode() {
  return request({
    url: 'securityCode/CreateSecurityCode',
    method: 'get'
  })
}

export function sendMessage(data) {
  return requestMessage({
    url: 'Message',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/websiteApi.js